import React, { useState } from "react";
import { Send, RotateCcw, Copy } from "lucide-react";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { ChatThread } from "./ChatThread";
import { useAiChat } from "./useAiChat";

const IDEAS = [
  "Write a WhatsApp message announcing our next Umrah group with price",
  "Write a Facebook post for Ramadan Umrah offer with hashtags",
  "Write a polite payment reminder for a pilgrim",
  "Write flyer text for Classic Umrah package in Bengali",
];

export const WritingHelper = () => {
  const [text, setText] = useState("");
  const chat = useAiChat({ storageKey: "buh_ai_writer_sid", streamPath: "/ai/write/stream", historyPath: "/ai/write/history", owner: true });
  const last = [...chat.messages].reverse().find((m) => m.role === "assistant" && m.content);
  const submit = () => { chat.send(text); setText(""); };
  const copy = () => { navigator.clipboard.writeText(last.content); toast.success("Copied"); };

  return (
    <Card className="glass border-gold/20 flex flex-col h-[640px]" data-testid="writing-helper">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gold/20">
        <p className="font-serif font-semibold text-gold">Writing helper</p>
        <div className="flex gap-2">
          {last && <Button size="sm" variant="outline" onClick={copy} data-testid="writer-copy-btn" className="h-8 gap-1 border-gold/40 text-gold"><Copy className="w-3.5 h-3.5" /> Copy last</Button>}
          <Button size="sm" variant="outline" onClick={chat.reset} data-testid="writer-new-btn" className="h-8 gap-1"><RotateCcw className="w-3.5 h-3.5" /> New</Button>
        </div>
      </div>
      <ChatThread messages={chat.messages} busy={chat.busy} testid="writer-thread" empty="Ask for any message, caption, post or reply. It uses your live package prices and dates." />
      {chat.messages.length === 0 && (
        <div className="flex flex-wrap gap-2 px-4 pb-3">
          {IDEAS.map((i, n) => <button key={i} onClick={() => chat.send(i)} data-testid={`writer-idea-${n}`} className="text-xs rounded-full border border-gold/30 px-3 py-1.5 text-emerald-100/80 hover:border-gold hover:text-gold transition-colors">{i}</button>)}
        </div>
      )}
      {chat.error && <p className="px-4 pb-1 text-xs text-red-300" data-testid="writer-error">{chat.error}</p>}
      <div className="flex gap-2 p-3 border-t border-gold/20">
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} placeholder="What should I write?" data-testid="writer-input"
          onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); submit(); } }} className="bg-card/60 resize-none" />
        <Button onClick={submit} disabled={chat.busy || !text.trim()} data-testid="writer-send-btn" className="bg-gold text-[#0a2e22] hover:bg-gold/90 h-auto"><Send className="w-4 h-4" /></Button>
      </div>
    </Card>
  );
};
